import React from "react";

const Maintenance = () => {
  return (
    <div className="maintenance-wrapper">
      <div className="maintenance-card">

        <img
          src={`${process.env.PUBLIC_URL}/assets/img/applogo.jfif`}
          alt="Maintenance"
          className="maintenance-image"
        />

        <h1>We're closing our app</h1>

        <div className="time-box-container">
          <div className="time-box">
            🌙 <span>12:00 AM</span>
          </div>

          <span className="separator">—</span>

          <div className="time-box">
            ☀️ <span>4:00 AM</span>
          </div>
        </div>

        <p className="maintenance-text">
          To improve system performance and complete scheduled maintenance,
          our portal will be unavailable from
          <strong> 12:00 AM to 4:00 AM.</strong>
        </p>

        <div className="divider">
          <span>♡</span>
        </div>

        <div className="wellbeing-section">
          <div className="heart-icon">💜</div>

          <div>
            <h4>Your experience matters.</h4>

            <p>
              We're working to serve you better.
              Thank you for your patience and support.
            </p>
          </div>
        </div>

        <div className="thank-you">
          💙 Thank you for understanding!
        </div>

      </div>
      <style>
        {
            `
            .maintenance-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #eaf0ff, #f8f9ff);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.maintenance-card {
  width: 100%;
  max-width: 650px;
  background: #fff;
  border-radius: 35px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.12);
}

.maintenance-image {
  width: 110px;
  max-width: 100%;
  margin-bottom: 20px;
}

.maintenance-card h1 {
  font-size: 24px;
  font-weight: 700;
  color: #0f1d67;
  margin-bottom: 25px;
}

.time-box-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.time-box {
  background: #eef0ff;
  color: #17266f;
  padding: 15px 25px;
  border-radius: 18px;
  font-size: 20px;
  font-weight: 600;
}

.separator {
  font-size: 2rem;
  color: #17266f;
}

.maintenance-text {
  font-size: 16px;
  color: #4d5575;
  line-height: 1.8;
  margin-bottom: 30px;
}

.divider {
  display: flex;
  align-items: center;
  color: #a0a6d6;
  margin: 15px 0;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #dcdff7;
}

.divider span {
  margin: 0 15px;
  font-size: 24px;
}

.wellbeing-section {
  display: flex;
  gap: 20px;
  align-items: center;
  text-align: left;
}

.heart-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #eef0ff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
}

.wellbeing-section h4 {
  color: #28306d;
  margin-bottom: 10px;
}

.wellbeing-section p {
  color: #5f6685;
  margin: 0;
  line-height: 1.6;
}

.thank-you {
  margin-top: 35px;
  font-size: 20px;
  font-weight: 700;
  color: #16276e;
}

@media (max-width: 768px) {
  .maintenance-card {
    padding: 30px 20px;
  }

  .maintenance-card h1 {
    font-size: 24px;
  }

  .maintenance-image {
    width: 110px;
  }

  .maintenance-text {
    font-size: 14px;
    margin-bottom:10px
  }

  .wellbeing-section {
    flex-direction: column;
    text-align: center;
  }
    .time-box {
    background: #eef0ff;
    color: #17266f;
    padding: 15px 15px;
    border-radius: 18px;
    font-size: 16px;
    font-weight: 600;
}
    .time-box-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    margin-bottom: 15px;
}
    .maintenance-image {
    width: 110px;
    max-width: 100%;
    margin-bottom: 15px;
}
    .heart-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #eef0ff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
}
    .thank-you {
    margin-top: 15px;
    font-size: 16px;
    font-weight: 700;
    color: #16276e;
}
}
            `
        }
      </style>
    </div>
  );
};

export default Maintenance;